import React from 'react'

function TenderTextSCFClassic() {
  return (
    <embed src="\pdfs\EA1.1.3_scf-classic_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSCFClassic